<ng-container [ngSwitch]="_provider">
  <!-- Material Icons (auto-detect SVG vs Font) -->
  <ng-container *ngSwitchCase="'material'">
    <mat-icon
      [class]="class"
      [svgIcon]="isMaterialSvgIcon ? _name : undefined"
      [style.width]="_size"
      [style.height]="_size"
      [style.font-size]="_size"
    >
      <ng-container *ngIf="!isMaterialSvgIcon">{{ _name }}</ng-container>
    </mat-icon>
  </ng-container>

  <!-- Tabler Icons -->
  <ng-container *ngSwitchCase="'tabler'">
    <i [class]="'ti ti-' + _name + (class ? ' ' + class : '')" [style.font-size]="_size"></i>
  </ng-container>
</ng-container>
